import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import {
  BsArrowReturnLeft,
  BsPencilFill,
  BsFillXCircleFill,
  BsThreeDotsVertical,
} from 'react-icons/bs';

import { useMessage } from '../../hooks/message';

import { MessageGeneric } from '../../interfaces/IMessage';
import { getInitials } from '../../services/function';
import { formatLocalDateTime } from '../../utils/dateTime';

const MessageChat: React.FC<any> = ({
  message,
  readOnly,
  seqUsuario,
  searchTextMessage,
}) => {
  const {
    setEditMessage,
    removeMensage,
    messages,
    messagesGroup,
    citarMessage,
    setCitarMessage,
  } = useMessage();
  const hour = formatLocalDateTime(message.dtEnvioMensagem);

  function escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  const highlightText = (html: string, term: string): string => {
    if (!term) return html; // Se não houver termo de pesquisa, retorne o HTML original

    try {
      // Escape os caracteres especiais do termo de busca
      const escapedTerm = escapeRegExp(term);

      // Use uma expressão regular para encontrar e substituir o termo
      const regex = new RegExp(`(${escapedTerm})`, 'gi');
      return html.replace(regex, '<span class="highlight">$1</span>');
    } catch (error) {
      console.error('Erro ao destacar texto:', error);
      return html;
    }
  };

  return (
    <div
      className={`d-flex flex-column w-100 ${
        message.seqUsuario === null ||
        (String(message.seqUsuario) !== seqUsuario && message.chatGroup)
          ? 'align-items-start'
          : 'align-items-end'
      } `}
      style={{ fontSize: '1.2rem', color: '#000' }}
    >
      <div
        style={{ width: '70%' }}
        className={`d-flex  ${
          message.seqUsuario === null ||
          (String(message.seqUsuario) !== seqUsuario && message.chatGroup)
            ? 'me-1 justify-content-start'
            : 'ms-1 justify-content-end'
        } `}
      >
        {message.seqUsuario === null ||
          (String(message.seqUsuario) !== seqUsuario && message.chatGroup && (
            <div
              style={{
                height: '3.3rem',
                marginTop: '0.4rem',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                backgroundColor:
                  message.cor === '' || !message.cor ? '#616161' : message.cor,
                borderRadius: '0.6875rem',
              }}
              className="d-flex align-items-center justify-content-center"
            >
              <span
                style={{
                  width: '3.3rem',
                  color: '#fff',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  fontWeight: '600',
                  wordWrap: 'break-word',
                }}
              >
                {getInitials(message.nomeUsuario)}
              </span>
            </div>
          ))}

        <div
          className={`d-flex flex-column ${
            message.seqUsuario === null ||
            (String(message.seqUsuario) !== seqUsuario && message.chatGroup)
              ? 'me-1 align-items-start'
              : 'ms-1 align-items-end me-2'
          } `}
        >
          <div className="ms-1 mb-0 small d-flex align-items-center">
            {`${
              message.seqUsuario === null
                ? message.nomeCliente
                : message.nomeUsuario
            }
         ${hour}`}
            {(message.seqUsuario === null ||
              String(message.seqUsuario) !== seqUsuario) &&
              !readOnly && (
                <Dropdown>
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    size="sm"
                    className="p-0 m-0 py-1"
                  >
                    <BsThreeDotsVertical
                      style={{ width: '1.1rem', height: '1.1rem' }}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="p-1">
                    <Dropdown.Item
                      className="bg-success text-white rounded mb-1"
                      onClick={() => {
                        setCitarMessage(message);
                      }}
                    >
                      Citar Mensagem
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            {String(message.seqUsuario) === seqUsuario && !readOnly && (
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  id="dropdown-basic"
                  size="sm"
                  className="p-0 m-0 py-1"
                >
                  <BsThreeDotsVertical
                    style={{ width: '1.1rem', height: '1.1rem' }}
                    className="me-1"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu className="p-1">
                  <Dropdown.Item
                    className="bg-success text-white rounded mb-1"
                    onClick={() => {
                      setCitarMessage(message);
                      setEditMessage({} as MessageGeneric);
                    }}
                  >
                    Citar Mensagem
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="bg-warning text-white rounded mb-1"
                    onClick={() => {
                      setEditMessage(message);
                      setCitarMessage({} as MessageGeneric);
                    }}
                  >
                    Editar Messagem
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="bg-danger text-white rounded"
                    onClick={() => {
                      removeMensage(
                        message.id,
                        message.seqMensagem,
                        messages,
                        messagesGroup,
                        message.chatGroup
                      );
                    }}
                  >
                    Excluir Mensagem
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>

          <div
            className={`d-inline-block border h-auto overflow-auto p-1
        ${message.seqMensagem === citarMessage.seqMensagem ? 'bg-success' : ''}
        ${message.ativo === 'N' ? 'bg-danger text-white' : ''}
        text-light`}
            translate="no"
            style={{
              borderRadius: '0.6875rem',
              backgroundColor:
                message.user === null ||
                String(message.seqUsuario) !== seqUsuario
                  ? '#474747'
                  : '#0075FF',
              borderTopRightRadius:
                message.user === null ||
                String(message.seqUsuario) !== seqUsuario
                  ? '0.6875rem'
                  : '0',

              borderTopLeftRadius:
                message.user === null ||
                String(message.seqUsuario) !== seqUsuario
                  ? '0'
                  : '0.6875rem',
            }}
          >
            {message.ativo === 'N' && (
              <>
                <BsFillXCircleFill
                  style={{ width: '1rem', height: '1rem' }}
                  className="ms-2 me-1 mt-1 mb-1"
                />
                <span style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
                  Deletada
                </span>
              </>
            )}
            {message.seqMensagemOrigem > 0 && (
              <>
                <BsPencilFill
                  style={{ width: '1rem', height: '1rem' }}
                  className="ms-2 me-1 mt-1 mb-1"
                />
                <span style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
                  Editado
                </span>
                <div
                  className="text-html ms-2 me-2 mt-0 mb-1 p-1 bg-warning bg-opacity-50 rounded text"
                  dangerouslySetInnerHTML={{
                    __html: highlightText(
                      message.mensagemOrigem,
                      searchTextMessage
                    ),
                  }}
                />
                <hr className="m-0 border-top border-2 ms-2 me-2" />
              </>
            )}
            {message.seqMensagemCitacao > 0 && (
              <>
                <BsArrowReturnLeft
                  style={{ width: '1rem', height: '1rem' }}
                  className="ms-1 me-1 mt-1"
                />
                <span style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
                  Citado
                </span>
                <div
                  className="text-html ms-2 me-2 mt-0 mb-1 p-1 bg-success bg-opacity-50 rounded"
                  dangerouslySetInnerHTML={{
                    __html: highlightText(
                      message.mensagemCitacao,
                      searchTextMessage
                    ),
                  }}
                />
                <hr className="m-0 border-top border-2 ms-2 me-2" />
              </>
            )}
            <div
              className="text-html ms-2 me-2"
              style={{ color: '#fff' }}
              dangerouslySetInnerHTML={{
                __html: highlightText(message.texto, searchTextMessage),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageChat;
